import React, { useEffect } from 'react'
import { X, AlertCircle, CheckCircle, Info } from 'lucide-react'
import { motion } from 'framer-motion'

const icons = {
  error: <AlertCircle className="w-4 h-4 text-red-400" />,
  success: <CheckCircle className="w-4 h-4 text-green-400" />,
  info: <Info className="w-4 h-4 text-blue-400" />
}

const Toast = ({ toast, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose()
    }, 5000)

    return () => clearTimeout(timer)
  }, [onClose])

  if (!toast) return null

  return (
    <motion.div
      initial={{ opacity: 0, y: 50, scale: 0.3 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, scale: 0.5, transition: { duration: 0.2 } }}
      className="flex items-center gap-3 bg-gray-800 border border-gray-700 rounded-lg shadow-lg p-4 mb-2"
    >
      {icons[toast.type]}
      <div className="flex flex-col">
        {toast.title && (
          <span className="text-sm font-medium text-gray-200">
            {toast.title}
          </span>
        )}
        <span className="text-sm text-gray-300">
          {toast.description}
        </span>
      </div>
      <button
        onClick={onClose}
        className="ml-2 p-1 hover:bg-gray-700 rounded-full transition-colors"
      >
        <X className="w-4 h-4 text-gray-400" />
      </button>
    </motion.div>
  )
}

export default Toast 